<template>
  <div v-on:click="exitmenu" class="page-effect">
    <!-- <TopMenu /> -->
    <section
      @click="onClickHandler"
      id="sectionId"
      class="sponsors-list-wrapper d-flex body-content exhibitor-details new-sponsor-details"
      onmouseover="exitmenu();"
      style="
        background-image: url('https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FBranding%2FEvent%20Background_2732x2048%20pixels.jpg?alt=media');
      "
    >
      <div class="container-fluid left-right-common-gap">
        <h1 id="headerText" class="page-head text-uppercase">
          <span
            class="pr-2"
            data-toggle="tooltip"
            data-placement="top"
            title
            data-original-title="Back"
          >
            <router-link
              id="anchExh"
              to="/sponsors"
              data-tag="sponsorsListBAck"
            >
              <!-- <a href="#" id="anchExh" v-on:click.prevent="goBack"> -->
              <svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                fill="#242432"
                width="24px"
                height="24px"
                viewBox="0 0 31.494 31.494"
                style="enable-background: new 0 0 31.494 31.494"
                xml:space="preserve"
              >
                <path
                  style="fill: #1e201d"
                  d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554 c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587 c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
                <g />
              </svg>
              <!-- </a> -->
            </router-link>
          </span>
          Sponsor Info
        </h1>
        <div
          class="sponsor-details-info"
          id="divsponsor"
          style="display: block"
        >
          <!--<span id="exhi_banner">
            <img
              src="https://CMS.e2m.live/write/Exhibitor/1c45c7ba-f187-48c8-9530-35f1b04cde6a.png"
              alt="A.T. Kearney"
            />
          </span>-->
          <div class="banner-bottom-strip">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="banner-bottom-strip-left d-flex">
                  <div class="media align-items-center" v-bind:d="id">
                    <span class="logo-hld" id="exhi_logo">
                      <!--<img src="https://CMS.e2m.live/write/Exhibitor/e83dc6ef-54f8-44bb-a23f-6d533161c133.jpeg" alt="A.T. Kearney">-->
                      <img v-bind:src="Image" v-bind:alt="Name" />
                    </span>
                    <div class="media-body ml-3">
                      <h4 id="exhi_name">{{ Name }}</h4>
                      <a
                        id="exhi_website"
                        title
                        data-placement="top"
                        data-toggle="tooltip"
                        target="_blank"
                        data-original-title="Website"
                        v-bind:href="'//' + Website"
                        data-tag="sponsorWebsite"
                        >{{ Website }}</a
                      >
                      <p class="mb-1" id="exhi_type">{{ Category }}</p>
                      <p v-if="BoothNo.lenght > 0" id="exhi_booth">
                        Booth #{{ BoothNo }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="banner-bottom-strip-right">
                  <div
                    class="rgt-editor-hld round-icon-hld round-icon-new-hld d-flex justify-content-end"
                  >
                    <ul class="ulHeaderSection p-0 m-0">
                      <li data-order="29"></li>
                      <!--<li data-order="60">
                        <span data-toggle="modal" data-target="#ReqMeetModal">
                          <a
                            data-toggle="tooltip"
                            data-placement="top"
                            title
                            class="icon-hld"
                            data-original-title="Request Meeting"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              width="38px"
                              height="35px"
                            >
                              <path
                                fill-rule="evenodd"
                                stroke="rgb(36, 36, 50)"
                                stroke-width="2px"
                                stroke-linecap="butt"
                                stroke-linejoin="miter"
                                fill="none"
                                d="M17.000,27.594 C17.000,22.387 22.358,18.976 25.607,17.958 C24.061,17.108 23.000,15.483 23.000,13.594 C23.000,10.832 25.239,8.594 28.000,8.594 C30.761,8.594 33.000,10.832 33.000,13.594 C33.000,15.483 31.939,17.108 30.393,17.958 C33.642,18.976 36.000,22.009 36.000,25.594 C36.000,30.012 32.418,33.000 28.000,33.000 L12.000,33.000 C7.582,33.000 4.000,30.012 4.000,25.594 C4.000,22.009 6.358,18.976 9.607,17.958 C8.061,17.108 7.000,15.483 7.000,13.594 C7.000,10.832 9.239,8.594 12.000,8.594 C14.761,8.594 17.000,10.832 17.000,13.594 C17.000,15.483 15.939,17.108 14.393,17.958 C17.642,18.976 23.000,22.063 23.000,27.594 "
                              />
                              <path
                                fill-rule="evenodd"
                                stroke="rgb(36, 36, 50)"
                                stroke-width="2px"
                                stroke-linecap="butt"
                                stroke-linejoin="miter"
                                fill="none"
                                d="M4.000,18.000 L4.000,12.000 M12.000,4.000 L33.000,4.000 C34.657,4.000 36.000,5.343 36.000,7.000 L36.000,18.000 "
                              />
                              <path
                                fill-rule="evenodd"
                                fill="rgb(36, 36, 50)"
                                d="M10.000,6.000 L6.000,6.000 L6.000,10.000 L4.000,10.000 L4.000,6.000 L-0.000,6.000 L-0.000,4.000 L4.000,4.000 L4.000,-0.000 L6.000,-0.000 L6.000,4.000 L10.000,4.000 L10.000,6.000 Z"
                              />
                            </svg>
                          </a>
                        </span>
                        <span class="tooltiptxt">Request a Callback</span>
                      </li>-->
                      <!--<li id="liChat">
                        <a
                          id="anchChat"
                          href="#"
                          v-on:click="StartBroadcast(Name,MappedContacts[0].Name,MappedContacts[0].AttendeeId,GlobalKeysData.broadcastbaseURL,GlobalKeysData.BroadcastStartURL,GlobalKeysData.BroadcastvalidityHours,GlobalKeysData.videoId,GlobalKeysData.videoCert,GlobalKeysData.BroadcastID,GlobalKeysData.ChannelPrefix,GlobalKeysData.BroadcastSpeakerApiUrl,GlobalKeysData.BroadcastAttendeeApiUrl);"
                          class="icon-hld no-bookmark"
                          title="Chat"
                          data-placement="top"
                          data-toggle="tooltip"
                        >
                          <svg
                            fill="#242432"
                            width="40"
                            height="40px"
                            viewBox="0 -26 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="m256 100c-5.519531 0-10 4.480469-10 10s4.480469 10 10 10 10-4.480469 10-10-4.480469-10-10-10zm0 0"
                            />
                            <path
                              d="m90 280c5.519531 0 10-4.480469 10-10s-4.480469-10-10-10-10 4.480469-10 10 4.480469 10 10 10zm0 0"
                            />
                            <path
                              d="m336 0c-90.027344 0-163.917969 62.070312-169.632812 140.253906-85.738282 4.300782-166.367188 66.125-166.367188 149.746094 0 34.945312 13.828125 68.804688 39 95.632812 4.980469 20.53125-1.066406 42.292969-16.070312 57.296876-2.859376 2.859374-3.714844 7.160156-2.167969 10.898437 1.546875 3.734375 5.191406 6.171875 9.238281 6.171875 28.519531 0 56.003906-11.183594 76.425781-30.890625 19.894531 6.78125 45.851563 10.890625 69.574219 10.890625 90.015625 0 163.898438-62.054688 169.628906-140.222656 20.9375-.929688 42.714844-4.796875 59.945313-10.667969 20.421875 19.707031 47.90625 30.890625 76.425781 30.890625 4.046875 0 7.691406-2.4375 9.238281-6.171875 1.546875-3.738281.691407-8.039063-2.167969-10.898437-15.003906-15.003907-21.050781-36.765626-16.070312-57.296876 25.171875-26.828124 39-60.6875 39-95.632812 0-86.886719-86.839844-150-176-150zm-160 420c-23.601562 0-50.496094-4.632812-68.511719-11.800781-3.859375-1.539063-8.269531-.527344-11.078125 2.539062-12.074218 13.199219-27.773437 22.402344-44.878906 26.632813 9.425781-18.058594 11.832031-39.347656 6.097656-59.519532-.453125-1.589843-1.292968-3.042968-2.445312-4.226562-22.6875-23.367188-35.183594-53.066406-35.183594-83.625 0-70.46875 71.4375-130 156-130 79.851562 0 150 55.527344 150 130 0 71.683594-67.289062 130-150 130zm280.816406-186.375c-1.152344 1.1875-1.992187 2.640625-2.445312 4.226562-5.734375 20.171876-3.328125 41.460938 6.097656 59.519532-17.105469-4.226563-32.804688-13.433594-44.878906-26.632813-2.808594-3.0625-7.21875-4.078125-11.078125-2.539062-15.613281 6.210937-37.886719 10.511719-58.914063 11.550781-2.921875-37.816406-21.785156-73.359375-54.035156-99.75h130.4375c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-161.160156c-22.699219-11.554688-48.1875-18.292969-74.421875-19.707031 5.746093-67.164063 70.640625-120.292969 149.582031-120.292969 84.5625 0 156 59.53125 156 130 0 30.558594-12.496094 60.257812-35.183594 83.625zm0 0"
                            />
                            <path
                              d="m256 260h-126c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h126c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
                            />
                            <path
                              d="m256 320h-166c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h166c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
                            />
                            <path
                              d="m422 100h-126c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h126c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
                            />
                          </svg>
                        </a>
                        <span class="tooltiptxt">Video Chat</span>
                      </li>-->
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="spkinfo-mid"
            style="background-color: #fff; padding: 21px"
          >
            <div class="row clearfix">
              <div class="col-md-12">
                <h3>Description</h3>
                <div id="exhi_details">
                  <p>
                    <span style="text-align: justify; font-size: 13.5pt">
                      <div v-html="Profile" />
                    </span>
                  </p>
                </div>
              </div>
              <div class="col-md-12">
                <div class="contact-info">
                  <ul class="m-0 p-0">
                    <li v-if="Email.length > 0" id="exhi_email_li">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="25px"
                        height="19px"
                      >
                        <path
                          fill-rule="evenodd"
                          fill="rgb(0, 0, 0)"
                          d="M0.001,18.999 L0.001,0.011 L25.007,0.011 L25.007,18.999 L0.001,18.999 ZM2.000,17.000 L7.000,10.000 L2.000,4.000 L2.000,17.000 ZM2.000,2.000 L11.000,11.000 C12.052,11.950 13.390,11.687 14.000,11.000 L23.000,2.000 L2.000,2.000 ZM22.000,17.000 L17.000,11.000 C15.024,12.994 14.356,13.000 13.000,13.000 C11.646,13.000 9.976,12.994 8.000,11.000 L4.000,17.000 L22.000,17.000 ZM18.000,10.000 L23.000,16.000 L23.000,4.000 L18.000,10.000 Z"
                        />
                      </svg>
                      <span id="exhi_email">
                        <a href="#">{{ Email }}</a>
                      </span>
                    </li>
                    <li id="exhi_phone_li">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="34px"
                        height="34px"
                      >
                        <path
                          fill-rule="evenodd"
                          fill="rgb(36, 36, 50)"
                          d="M23.631,19.889 C23.595,19.792 23.370,19.651 22.954,19.463 C22.841,19.404 22.681,19.324 22.474,19.222 C22.266,19.121 22.077,19.027 21.908,18.941 C21.739,18.856 21.580,18.773 21.432,18.692 C21.408,18.676 21.334,18.630 21.209,18.552 C21.085,18.474 20.979,18.417 20.893,18.379 C20.807,18.342 20.723,18.323 20.639,18.323 C20.521,18.323 20.372,18.399 20.194,18.552 C20.016,18.704 19.853,18.870 19.705,19.050 C19.556,19.229 19.399,19.395 19.233,19.547 C19.067,19.700 18.930,19.776 18.823,19.776 C18.770,19.776 18.703,19.763 18.623,19.736 C18.543,19.709 18.482,19.687 18.440,19.668 C18.399,19.649 18.328,19.612 18.227,19.555 C18.126,19.499 18.069,19.469 18.058,19.463 C17.244,19.056 16.547,18.591 15.965,18.066 C15.384,17.542 14.867,16.913 14.416,16.179 C14.410,16.169 14.376,16.118 14.314,16.027 C14.251,15.936 14.210,15.872 14.189,15.834 C14.168,15.797 14.143,15.742 14.113,15.670 C14.084,15.597 14.069,15.537 14.069,15.489 C14.069,15.393 14.153,15.269 14.323,15.120 C14.492,14.970 14.676,14.828 14.875,14.694 C15.073,14.560 15.257,14.413 15.427,14.252 C15.596,14.092 15.680,13.958 15.680,13.851 C15.680,13.776 15.660,13.700 15.618,13.622 C15.576,13.545 15.513,13.450 15.427,13.337 C15.341,13.225 15.289,13.158 15.271,13.136 C15.182,13.003 15.090,12.859 14.995,12.707 C14.900,12.554 14.796,12.384 14.683,12.197 C14.570,12.010 14.481,11.865 14.416,11.764 C14.208,11.389 14.051,11.185 13.944,11.153 C13.903,11.137 13.840,11.129 13.757,11.129 C13.597,11.129 13.388,11.156 13.130,11.210 C12.871,11.263 12.668,11.319 12.520,11.378 C12.223,11.491 11.908,11.817 11.576,12.358 C11.273,12.861 11.122,13.359 11.122,13.851 C11.122,13.996 11.132,14.136 11.153,14.273 C11.174,14.409 11.211,14.563 11.264,14.734 C11.318,14.906 11.361,15.033 11.393,15.116 C11.426,15.199 11.487,15.347 11.576,15.561 C11.665,15.775 11.718,15.906 11.736,15.955 C11.944,16.479 12.190,16.948 12.475,17.360 C12.944,18.045 13.584,18.753 14.394,19.483 C15.204,20.214 15.989,20.791 16.749,21.213 C17.206,21.470 17.725,21.693 18.307,21.880 C18.360,21.896 18.506,21.944 18.743,22.024 C18.980,22.105 19.145,22.160 19.237,22.189 C19.329,22.218 19.470,22.257 19.660,22.305 C19.850,22.354 20.021,22.387 20.172,22.406 C20.323,22.425 20.479,22.434 20.639,22.434 C21.185,22.434 21.737,22.297 22.295,22.024 C22.895,21.725 23.257,21.441 23.382,21.173 C23.447,21.040 23.509,20.856 23.569,20.623 C23.628,20.390 23.658,20.202 23.658,20.057 C23.658,19.982 23.649,19.926 23.631,19.889 L23.631,19.889 Z"
                        />
                        <path
                          fill-rule="evenodd"
                          stroke-width="2px"
                          stroke="rgb(36, 36, 50)"
                          fill-opacity="0"
                          fill="rgb(3, 97, 159)"
                          d="M17.000,5.000 C23.627,5.000 29.000,10.373 29.000,17.000 C29.000,23.627 23.627,29.000 17.000,29.000 C10.373,29.000 5.000,23.627 5.000,17.000 C5.000,10.373 10.373,5.000 17.000,5.000 Z"
                        />
                      </svg>
                      <span v-if="Phone.length > 0" id="exhi_phone">
                        <a>{{ Phone }}</a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="panel-group" id="accordion">
              <div
                v-if="MappedContacts.contactcount > 0"
                class="panel panel-default"
                id="attendees_panel"
                style="display: block"
              >
                <div class="panel-heading">
                  <h4 class="panel-title">
                    <a
                      id="acc"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapse1"
                      aria-expanded="true"
                    >
                      <h2>Contacts</h2>
                      <h3 class="sessions-hdr-next">
                        <span id="attendees_count">{{
                          MappedContacts.contactcount
                        }}</span>
                        Attendee(s)
                      </h3>
                    </a>
                  </h4>
                </div>
                <div id="collapse1" class="panel-collapse collapse in show">
                  <div
                    class="panel-body"
                    v-for="contact in MappedContacts"
                    v-bind:key="contact.AttendeeId"
                  >
                    <div class="sw-hld">
                      <div class="sw-txt-r">
                        <div class="row">
                          <div class="col-4">
                            <img
                              v-bind:src="contact.ProfilePictureURL"
                              v-bind:alt="contact.Name"
                            />
                          </div>
                          <div class="col-8">
                            <p class="m-0">
                              <strong>{{ contact.Name }}</strong>
                              <br />
                              {{ contact.Designation }}
                              <br />
                              <span>{{ contact.Company }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <span>
                          <a
                            href="#"
                            v-on:click="
                              StartBroadcast(
                                GlobalKeysData.BroadcastStartURL,
                                GlobalKeysData.videoParamsEncryptURL,
                                GlobalKeysData.IsBroadcastInNewTab,
                                id,
                                Name,
                                contact.Name,
                                contact.AttendeeId,
                                GlobalKeysData.broadcastbaseURL,
                                GlobalKeysData.BroadcastStartURL,
                                GlobalKeysData.BroadcastvalidityHours,
                                GlobalKeysData.videoId,
                                GlobalKeysData.BroadcastCertificate,
                                GlobalKeysData.BroadcastID,
                                GlobalKeysData.ChannelPrefix,
                                GlobalKeysData.BroadcastSpeakerApiUrl,
                                GlobalKeysData.BroadcastAttendeeApiUrl
                              );
                              return false;
                            "
                            data-tag="StartBroadcast"
                          >
                            <svg
                              fill="#242432"
                              width="40"
                              height="40px"
                              viewBox="0 -26 512 512"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="m256 100c-5.519531 0-10 4.480469-10 10s4.480469 10 10 10 10-4.480469 10-10-4.480469-10-10-10zm0 0"
                              />
                              <path
                                d="m90 280c5.519531 0 10-4.480469 10-10s-4.480469-10-10-10-10 4.480469-10 10 4.480469 10 10 10zm0 0"
                              />
                              <path
                                d="m336 0c-90.027344 0-163.917969 62.070312-169.632812 140.253906-85.738282 4.300782-166.367188 66.125-166.367188 149.746094 0 34.945312 13.828125 68.804688 39 95.632812 4.980469 20.53125-1.066406 42.292969-16.070312 57.296876-2.859376 2.859374-3.714844 7.160156-2.167969 10.898437 1.546875 3.734375 5.191406 6.171875 9.238281 6.171875 28.519531 0 56.003906-11.183594 76.425781-30.890625 19.894531 6.78125 45.851563 10.890625 69.574219 10.890625 90.015625 0 163.898438-62.054688 169.628906-140.222656 20.9375-.929688 42.714844-4.796875 59.945313-10.667969 20.421875 19.707031 47.90625 30.890625 76.425781 30.890625 4.046875 0 7.691406-2.4375 9.238281-6.171875 1.546875-3.738281.691407-8.039063-2.167969-10.898437-15.003906-15.003907-21.050781-36.765626-16.070312-57.296876 25.171875-26.828124 39-60.6875 39-95.632812 0-86.886719-86.839844-150-176-150zm-160 420c-23.601562 0-50.496094-4.632812-68.511719-11.800781-3.859375-1.539063-8.269531-.527344-11.078125 2.539062-12.074218 13.199219-27.773437 22.402344-44.878906 26.632813 9.425781-18.058594 11.832031-39.347656 6.097656-59.519532-.453125-1.589843-1.292968-3.042968-2.445312-4.226562-22.6875-23.367188-35.183594-53.066406-35.183594-83.625 0-70.46875 71.4375-130 156-130 79.851562 0 150 55.527344 150 130 0 71.683594-67.289062 130-150 130zm280.816406-186.375c-1.152344 1.1875-1.992187 2.640625-2.445312 4.226562-5.734375 20.171876-3.328125 41.460938 6.097656 59.519532-17.105469-4.226563-32.804688-13.433594-44.878906-26.632813-2.808594-3.0625-7.21875-4.078125-11.078125-2.539062-15.613281 6.210937-37.886719 10.511719-58.914063 11.550781-2.921875-37.816406-21.785156-73.359375-54.035156-99.75h130.4375c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-161.160156c-22.699219-11.554688-48.1875-18.292969-74.421875-19.707031 5.746093-67.164063 70.640625-120.292969 149.582031-120.292969 84.5625 0 156 59.53125 156 130 0 30.558594-12.496094 60.257812-35.183594 83.625zm0 0"
                              />
                              <path
                                d="m256 260h-126c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h126c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
                              />
                              <path
                                d="m256 320h-166c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h166c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
                              />
                              <path
                                d="m422 100h-126c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h126c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
                              />
                            </svg>
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="fileLength > 0"
                class="panel panel-default"
                id="resources_panel"
                style
              >
                <div class="panel-heading">
                  <h4 class="panel-title">
                    <a
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapse2"
                    >
                      <h2>Brochures</h2>
                    </a>
                  </h4>
                </div>
                <div id="collapse2" class="panel-collapse collapse">
                  <div class="panel-body" id="resource_body">
                    <div
                      class="rosource-listing"
                      v-for="(file, index) in Files"
                      v-bind:key="file.index"
                    >
                      <div class="d-flex justify-content-between">
                        <div class="media align-items-center">
                          <span class="logo-hld">
                            <svg
                              version="1.1"
                              width="40px"
                              id="Layer_1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              x="0px"
                              y="0px"
                              viewBox="0 0 512 512"
                              fill="rgb(36, 36, 50)"
                              style="enable-background: new 0 0 512 512"
                              xml:space="preserve"
                            >
                              <g>
                                <g>
                                  <g>
                                    <path
                                      d="M256,0C114.833,0,0,114.844,0,256s114.833,256,256,256s256-114.844,256-256S397.167,0,256,0z M256,490.667	C126.604,490.667,21.333,385.396,21.333,256S126.604,21.333,256,21.333S490.667,126.604,490.667,256S385.396,490.667,256,490.667	z"
                                    />
                                    <path
                                      d="M357.771,247.031l-149.333-96c-3.271-2.135-7.5-2.25-10.875-0.396C194.125,152.51,192,156.094,192,160v192	c0,3.906,2.125,7.49,5.563,9.365c1.583,0.865,3.354,1.302,5.104,1.302c2,0,4.021-0.563,5.771-1.698l149.333-96	c3.042-1.958,4.896-5.344,4.896-8.969S360.813,248.99,357.771,247.031z M213.333,332.458V179.542L332.271,256L213.333,332.458z"
                                    />
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </span>
                          <div class="media-body ml-3">
                            <a v-bind:href="file[index]" target="_blank">
                              <h4>A Conference Call in Real Life</h4>
                            </a>
                          </div>
                        </div>
                        <a
                          style="display: none"
                          class="no-bookmark themeiconbg"
                          title
                          data-placement="left"
                          data-toggle="tooltip"
                          href="javascript:void(0);"
                          data-original-title="Bookmark"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="42px"
                            height="42px"
                          >
                            <path
                              fill-rule="evenodd"
                              stroke-width="2px"
                              stroke="rgb(102, 102, 112)"
                              fill-opacity="0"
                              fill="rgb(3, 97, 159)"
                              d="M21.000,5.000 C29.837,5.000 37.000,12.163 37.000,21.000 C37.000,29.837 29.837,37.000 21.000,37.000 C12.163,37.000 5.000,29.837 5.000,21.000 C5.000,12.163 12.163,5.000 21.000,5.000 Z"
                            />
                            <path
                              fill-rule="evenodd"
                              fill="rgb(102, 102, 112)"
                              d="M20.989,12.000 L23.866,17.144 L29.717,18.252 L25.644,22.538 L26.383,28.366 L20.989,25.872 L15.595,28.366 L16.334,22.538 L12.261,18.252 L18.112,17.144 L20.989,12.000 "
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="ReqMeetModal" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header" style="width: 100%">
              <h4 class="modal-title">&nbsp;&nbsp;Request a Call Back</h4>
              <button type="button" class="close" data-dismiss="modal">
                ×
              </button>
            </div>
            <div class="modal-body">
              <iframe
                src="https://engage.zoebot.ai/zoecalv3e2m/home.php?cnt=1&amp;source=e2m-home-page"
                width="100%"
                height="540px"
                frameborder="0"
                scrolling="no"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="ReqVimeoModal" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header" style="width: 100%">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                id="btnVideoClose"
              >
                ×
              </button>
            </div>
            <div class="modal-body">
              <iframe
                id="abc_frame"
                width="100%"
                height="440px"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade modal-container"
        id="modalOpenBroadcast"
        role="dialog"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <button
              v-on:click="CloseModal()"
              type="button"
              class="close"
              title="Close"
              data-tag="CloseModalBroadcast"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#ffffff"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div class="modal-body">
              <iframe
                id="iframeBroadcast"
                src
                height="100%"
                width="100%"
                allow="camera;microphone"
              ></iframe>
            </div>
          </div>
        </div>
        <b-modal ref="my-modal" hide-footer title="Using Component Methods">
          <div class="d-block text-center"></div>
          <b-button
            class="mt-3"
            variant="outline-danger"
            block
            @click="hideModal"
            data-tag="BroadcastClose"
            >Close Me</b-button
          >
          <b-button
            class="mt-2"
            variant="outline-warning"
            block
            @click="toggleModal"
            data-tag="BroadcastToggle"
            >Toggle Me</b-button
          >
        </b-modal>
      </div>
    </section>
  </div>
</template>

<script>
import db from "../components/firebaseInit";
//import TopMenu from "@/components/TopMenu.vue";
import jQuery from "jquery";
import store from "../store";
import analytics from "@/components/Analytics";
import axios from "axios";
//import router from '../router';
let $ = jQuery;
var self;
export default {
  name: "SponsorDetails",

  data() {
    return {
      id: null,
      Name: null,
      BoothNo: null,
      Category: null,
      Email: null,
      Website: null,
      Image: null,
      Profile: null,
      Phone: null,
      MappedContacts: [],
      GlobalKeysData: {
        // id: "SN1591285924312",
        // Name: "Opening Key Note",
        broadcastbaseURL:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/",
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        videoId: "605f401455444442838e00cb859c037b",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
      },
    };
  },
  components: {
    //TopMenu
  },
  async mounted() {
    store.commit("addSponsorDetails", true);
    $("#topmenu").show();
    if ($("#ulLeftMenu li").length > 0) {
      $("#leftMenuParent").show();
      $("#leftmenu").show();
    } else {
      $("#leftMenuParent").hide();
      $("#leftmenu").hide();
    }
    $("#btnAddUserView").click();
    self = this;
    self.scroll();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //-------------dynamic font selection --------------------------------------
    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        debugger;
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }
    //-------------dynamic font selection --------------------------------------
    //-------------------FAVICONJOB------------------------------------------------------------
    debugger;
    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------
    /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    var brandingData;
    try {
      brandingData = await self.getBrandingJSONDetails(
        obj.eventcollectionname + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        if (brandingData.data.EventInfo != undefined) {
          if (brandingData.data.EventInfo.BodyTextColor != undefined) {
            self.textColor = brandingData.data.EventInfo.BodyTextColor;
          } else {
            self.textColor = "black";
          }
        } else {
          self.textColor = "black";
        }
        console.log("BodyTextColor :- " + self.textColor);
        $("#headerText").css("color", self.textColor);
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
    }
    //------------------------------------------------------------------------------
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
    $("#sectionId").css(
      "background-image",
      "url(" + obj.EventBranding[0].eventBGImage + ")"
    );
    self.eventId = obj.eventid;
    //alert(self.eventId);
    self.userid = obj.user[0].id;
    self.setFirebaseAppsettings();
  },
  methods: {
    // goBack: function()
    // {
    //   router.push({ name: 'SponsorList' })
    // },
    StartBroadcast: function (
      BroadcastStartURL,
      videoParamsEncryptURL,
      IsBroadcastInNewTab,
      ExhibitorId,
      UserFirstname,
      ChatFirstname,
      chatToId,
      broadcastbaseURL,
      BroadcastURL,
      BroadcastvalidityHours,
      videoId,
      videoCert,
      BroadcastID,
      ChannelPrefix,
      BroadcastSpeakerApiUrl,
      BroadcastAttendeeApiUrl
    ) {
      var OnAirVCount = this.readCookieForVideo("onairvcount");
      var videoLaunchFlag = true;
      if (OnAirVCount != null) {
        if (parseInt(OnAirVCount) >= 1) {
          if (
            !confirm(
              "An active OnAir video seems to be running, it is recommended to open one video at a time for best performance. Do you still want to open the video in another tab?"
            )
          ) {
            videoLaunchFlag = false;
          }
        }
      }

      if (videoLaunchFlag) {
        console.log("BroadcastSpeakerApiUrl = " + BroadcastSpeakerApiUrl);
        console.log("BroadcastAttendeeApiUrl = " + BroadcastAttendeeApiUrl);
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        var clntid = obj.client[0].id;
        var usrid = obj.user[0].id;
        var evntid = obj.eventid;

        var varchannelName = "";

        varchannelName =
          ChannelPrefix +
          "_" +
          evntid.substring("1") +
          "_" +
          ExhibitorId +
          "-" +
          chatToId.toString() +
          "_o2o";

        console.log(varchannelName);
        var SessionTitle =
          UserFirstname + " & " + ChatFirstname + " [Video Call] ";

        //Video URL with encrypted parameter
        console.log(
          "Parameters - url - " +
            videoParamsEncryptURL +
            "broadcastTypeUrl- " +
            BroadcastStartURL +
            "BroadcastvalidityHours - " +
            BroadcastvalidityHours +
            "channelid - " +
            varchannelName +
            "usrid - " +
            usrid +
            "SessionTitle - " +
            SessionTitle +
            " clntid - " +
            clntid
        );
        this.getEncryptedVideoURLParams(
          videoParamsEncryptURL,
          BroadcastStartURL,
          BroadcastvalidityHours,
          varchannelName,
          usrid,
          SessionTitle,
          clntid,
          function (videoURL, UserID) {
            // alert(videoURL);
            console.log(UserID);
            if (IsBroadcastInNewTab) {
              //window.parent.location.reload();
              window.open(videoURL, "_blank");
            } else {
              $("#iframeBroadcast").attr(
                "src",
                videoURL + "&t=" + new Date().getTime()
              );
              $("#modalOpenBroadcast").modal();
            }
          }
        );
      }
    },
    setFirebaseAppsettings: function () {
      //var obj = JSON.parse(window.localStorage.getItem("my-app"));
      debugger;
      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");

      docRef.get().then(function (doc) {
        if (doc.exists) {
          self.GlobalKeysData.BroadcastID = doc.data().AppIDRTC;
          self.GlobalKeysData.BroadcastCertificate = doc.data().CertificateRTC;
          self.GlobalKeysData.BroadcastSpeakerApiUrl = doc.data().SpeakerTokenURL;
          self.GlobalKeysData.BroadcastAttendeeApiUrl = doc.data().AttendeeTokenURL;
          self.GlobalKeysData.BroadcastStartURL = doc.data().BroadcastBaseURL;
          self.GlobalKeysData.BroadcastViewURL = doc.data().AudienceBaseURL;
          self.GlobalKeysData.BroadcastvalidityHours = doc.data().TokenValidityHours;
          self.GlobalKeysData.ChannelPrefix = doc.data().ChannelPrefix;
          self.GlobalKeysData.videoParamsEncryptURL = doc.data().EncryptionURL;
        }
      });
    },
    getEncryptedVideoURLParams: function (
      videoParamsEncryptURL,
      VideoBaseURL,
      TokenValidityHours,
      ChannelID,
      UserID,
      SessionTitle,
      clientId
    ) {
      console.log(
        "qString - channelName - " +
          ChannelID.toString() +
          " userId- " +
          parseInt(UserID) +
          " validityHours - " +
          parseInt(TokenValidityHours) +
          " isScreen - 0" +
          " sname - " +
          SessionTitle.toString() +
          " clientID - " +
          clientId
      );

      var qString = {
        channelName: ChannelID.toString(),
        userId: parseInt(UserID),
        validityHours: parseInt(TokenValidityHours),
        isScreen: 0,
        sname: SessionTitle.toString(),
        stime: "",
        clientId: clientId,
      };
      var encParam = "";
      var videoURL = VideoBaseURL;

      self.showLoader();
      let headers = {
        "Content-Type": "application/json",
      };
      axios
        .post(videoParamsEncryptURL, JSON.stringify(qString), {
          headers: headers,
        })
        .then((response) => {
          let data = response.data;
          if (typeof data != "undefined") {
            self.hideLoader();
            let lStatusCode = 0;
            lStatusCode = data.status;
            if (lStatusCode == 0) {
              encParam = data.result;
              videoURL = videoURL + "?vt=" + encParam;
              //  callBackFunction(videoURL, UserID);
              console.log("Get Encrypt URL API Call Success");
            } else {
              self.hideLoader();
              alert("Error initiating video call. Please retry. ");
            }
          } else {
            self.hideLoader();
            alert("Error initiating video call. Please retry. ");
          }
        })
        .catch((error) => {
          console.log("error--", error);
          self.hideLoader();
          alert("Error initiating video call. Please retry. ");
        });
    },
    callAjaxService: function (
      serviceUrl,
      requestData,
      cacheName,
      refreshCache,
      broadcastbaseURL,
      callBackFunction
    ) {
      // alert(broadcastbaseURL);
      var e2mToken =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySUQiOiIxNDQzMDUiLCJzeXN0ZW1UeXBlIjoiNiIsIm5iZiI6MTU5MTY0ODU4NywiZXhwIjoxNTkxNjUwMzg3LCJpYXQiOjE1OTE2NDg1ODcsImlzcyI6InNlbGYiLCJhdWQiOiIqIn0.aTEXVwBOM2AU3oHHyWTzJ6EP4UmsHiBc7Wrqpv9xNEY"; // JSON.parse(sessionStorage.getItem('e2mt'));
      var settings = {
        url: broadcastbaseURL + serviceUrl,
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
          Authorization: "2c560485-d443-46e5-9f50-7a5535b24931",
          OS: "WEB",
          eToken: e2mToken,
        },
        data: JSON.stringify(requestData),
      };

      $.ajaxSetup({
        url: serviceUrl,
        beforeSend: function () {},
        complete: function () {
          //alert('4');
        },
      });
      $.ajax(settings)
        .done(function (response) {
          //alert(JSON.stringify(response));
          callBackFunction(response);
        })
        .fail(function (xhr) {
          var errorMessage = xhr.status + ": " + xhr.statusText;
          alert(errorMessage);
        });
    },
    hideModal: function () {
      this.$refs["my-modal"].hide();
    },
    CloseModal: function () {
      $("#modalOpenBroadcast").modal("hide");
      $("#iframeBroadcast").attr("src", "");
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    scroll: function () {
      window.onscroll = () => {
        //alert("scroll");
        if (!self.IsSearchMode) {
          let bottomOfWindow =
            document.documentElement.scrollTop + window.innerHeight + 1 >=
            document.documentElement.offsetHeight;
          if (bottomOfWindow) {
            //this.AddAnalitics(event, "scroll");
          }
        }
      };
    },
  },
  beforeRouteEnter(to, from, next) {
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    console.log("EventColName : " + obj.eventcollectionname);
    db.collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
      .doc("SponsorList")
      .collection("Sponsors")
      .doc(to.params.sid)
      .get()
      .then((doc) => {
        next((vm) => {
          (vm.id = doc.id),
            (vm.Name = doc.data().Name),
            (vm.BoothNo = doc.data().BoothNo),
            (vm.Category = doc.data().Category),
            (vm.Email = doc.data().Email),
            (vm.Website = doc.data().Website),
            (vm.Profile = doc.data().Profile),
            (vm.Phone = doc.data().Phone),
            (vm.Image = vm.getCDNUrl(doc.data().Logo)),
            (vm.MappedContacts = doc.data().MappedContacts),
            (vm.contactcount = doc.data().MappedContacts.length),
            (vm.Files = doc.data().Files),
            (vm.fileLength = doc.data().Files.length);
        });
      })
      .catch((error) => {
        alert(error);
      });
  },
};
</script> 
